define('formkit/behavior/new.section.behavior',['require','exports','module','underscore','marionette'],function(require, exports, module) {
  var _  = require('underscore');
  var Mn = require('marionette');

  var EVENT_SEPARATOR = ' ';

  var AddNewSectionBehavior = Mn.Behavior.extend({
    defaults: {
      // events that trigger insertion of new section
      events: '',

      // when true, new section will be inserted whenever there are
      // no sections
      insertNewSectionByDefault: true,

      sectionTemplateObjectTypeName: 'Section'
    },

    initialize: function() {

      this.listenToOnce(this.view, 'before:render', function() {

        if (this.getOption('insertNewSectionByDefault')) {
          this.setupInsertNewSectionByDefault();
        }

        this.setupAddNewSectionEvents();
      });
    },

    setupInsertNewSectionByDefault: function() {
      var templateModel = this.view.form.getTemplateModel();
      var templateObjectTypeCollection = this.view.form.getTemplateObjectTypeCollection();

      if (!this.view.form.util.hasChildren(templateModel)) {
        this.insertNewSection();
      }

      this.listenTo(templateModel, 'remove:child', _.debounce(function(){
        if (!this.view.form.util.hasChildren(templateModel)) {
          this.insertNewSection();
        }
      }));
    },

    setupAddNewSectionEvents: function() {
      var events = this.getOption('events').split(EVENT_SEPARATOR);

      _.each(events, function(event) {
        this.listenTo(this.view, event, this.insertNewSection);
      }, this);
    },

    insertNewSection: function() {
      var parent = this.view.form.getTemplateModel();
      var sectionTemplateObjectTypeName = this.getOption('sectionTemplateObjectTypeName');

      var newSection = this.view.form.insertTemplateObject(parent, {
        type: this.view.form.findTemplateObjectTypeByName(sectionTemplateObjectTypeName),
        text: 'Section'
      });

      if (this.view.form.util.childCount(parent) == 1) {
        this.view.form.setActiveSectionModel(newSection);
      }
    }
  })
  module.exports = AddNewSectionBehavior;
});

